/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.describeRepo'

export { $nsid }

/** Get information about an account and repository, including the list of collections. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({ repo: l.string({ format: 'at-identifier' }) }),
  l.jsonPayload({
    handle: l.string({ format: 'handle' }),
    did: l.string({ format: 'did' }),
    didDoc: l.lexMap(),
    collections: l.array(l.string({ format: 'nsid' })),
    handleIsCorrect: l.boolean(),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
